export enum Variant {
  DEFAULT = 'default',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  DANGER = 'danger',
  GOLDEN = 'golden',
}
